import React, { Fragment, useState } from 'react';
import CollectionPromo from './CollectionPromo.jsx';
import ProductItem from './ProductItem.jsx';
import handleize from '../utils/handleize.js';

function CollectionGroupTitle(props) {
  if (props.isDesktop && props.desktopTitle && props.desktopTitle !== props.title) {
    if (props.desktopTitle !== '') {
      if (props.desktopTitle.includes('|')) {
        const titleArray = props.desktopTitle.split('|');
        return <div className="collection-group-heading">
          <h2 className="collection-group-heading2">{titleArray[0]}</h2>
          <h3 className="collection-group-heading3">{titleArray[1]}</h3>
        </div>
      }
      return <h2 className="collection-group-heading">{props.desktopTitle}</h2>
    }
  } else {
    if (props.title !== '') {
      if (props.title.includes('|')) {
        const titleArray = props.title.split('|');
        return <div className="collection-group-heading">
          <h2 className="collection-group-heading2">{titleArray[0]}</h2>
          <h3 className="collection-group-heading3">{titleArray[1]}</h3>
        </div>
      }
      return <h2 className="collection-group-heading">{props.title}</h2>
    }
  }
  return null
}

export default function CollectionGroup(props) {
  const [limit, setLimit] = useState(true);
  const groupHandle = handleize(props.group.group);
  let cName = `product-group product-group-${props.collectionHandle}-${handleize(props.group.group)}`;
  if (props.group.border) {
    cName += ' hide-border';
  }
  cName += ` layout-${props.layout}`
  
  return (
    <section className={cName} data-group-handle={handleize(props.group.group)} role="rowgroup">
      <CollectionGroupTitle title={props.group.title} desktopTitle={props.group.desktopTitle} isDesktop={props.isDesktop} />
      <ul className="products" role="row">
        {props.group.products.map((product, i) => {
          if (props.isDesktop && limit && props.group.limit && props.group.limit === i) {
            return <li className="view-more-block promo-block" role="cell" key={i}>
              <span className="promo-block--button">
                <a onClick={() => setLimit(false)} className="promo-block--button-link view-more-link">
                  + Expand To See More Colors
                </a>
              </span>
            </li>
          }
          if (props.isDesktop && limit && props.group.limit && props.group.limit < i) {
            return (null);
          }
          const thumbGroupTag = product.tags.find(tag => tag.startsWith('thumbnails:'));
          let thumbnails = [];
          if (props.group.hideThumbnails && props.layout !== 'expanded') {
            thumbnails = false;
          } else if (thumbGroupTag) {
            const thumbGroup = thumbGroupTag.replace('thumbnails:', '');
            thumbnails = props.thumbnails[thumbGroup];
            if (thumbnails && thumbnails.length === 0) {
              thumbnails = false;
            }
          } else {
            thumbnails = false;
          }

          let inlineThumbs = false;
          if (thumbGroupTag && props.layout === 'expanded' && !props.group.hideThumbnails) {
            inlineThumbs = true;
          }

          const promoBlocks = props.blocks.filter(block => block.product === product.handle);
          const isOverrideImage = product.overrideImage || false

          if (!isOverrideImage && product.images && Object.keys(product.section_image).length) {
            let handle = props.collectionHandle + '_' + groupHandle;
            let sectionImage = product.section_image[handle] || product.section_image['all']
            if (sectionImage) {
              const parts = sectionImage.split(',');
              const defaultImageIndex = (parts[0] < 1 ? 1 : parts[0]) - 1; 
              const hoverImageIndex = (parts[1] < 1 ? 1 : parts[1]) - 1;

              if (product.images[defaultImageIndex]) {
                product.image = product.images[defaultImageIndex]
              }

              if (product.images[hoverImageIndex]) {
                product.hoverImage = product.images[hoverImageIndex]
              }
            }
          }

          return <Fragment key={i}>
            <CollectionPromo isDesktop={props.isDesktop} promoBlocks={promoBlocks} productTitle={product.title} position="before" />
            <ProductItem {...product} layout={props.layout} collectionHandle={props.collectionHandle} thumbnails={thumbnails} inlineThumbs={inlineThumbs} isDesktop={props.isDesktop} columnCount={props.columnCount} />
            <CollectionPromo isDesktop={props.isDesktop} promoBlocks={promoBlocks} productTitle={product.title} position="after" />
          </Fragment>
        })}
      </ul>
      {props.group.texts && 
        <CollectionPromo isDesktop={props.isDesktop} promoBlocks={props.group.texts} position="before" htmlTag="div" />
      }
    </section>
  )
}